import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Plus, CalendarDays, User, Table2 } from 'lucide-react';

export function BottomNav() {
  return (
    <nav className="bottom-nav">
      <NavLink to="/" end>
        <LayoutDashboard size={20} />
        <span>Dashboard</span>
      </NavLink>
      <NavLink to="/demandas">
        <Table2 size={20} />
        <span>Demandas</span>
      </NavLink>
      <NavLink to="/nova-demanda">
        <Plus size={20} />
        <span>Nova</span>
      </NavLink>
      <NavLink to="/calendario">
        <CalendarDays size={20} />
        <span>Agenda</span>
      </NavLink>
      <NavLink to="/perfil">
        <User size={20} />
        <span>Perfil</span>
      </NavLink>
    </nav>
  );
}
